


export const CurrencyCommaRemoval = (val) => {
  return val.replace(/,/g, "");
}

